import { Link } from "@ambiguous/link";
import { Modal } from "@assets/tsx/modal";
import OutsideAlerter from "@assets/tsx/outsideClicker";
import { useI18n } from "@wordpress/react-i18n";
import React, { useEffect, useState } from "react";
import LtgImage from '@assets/tsx/image';
export default function Image({ lightbox, image, mask, url, url__props, image_source, prefetch }) {
    let imageData = image;
    if (image_source === 'featured') {
        imageData = prefetch === null || prefetch === void 0 ? void 0 : prefetch.featured_image;
    }
    if (lightbox === 'yes')
        return React.createElement(ImageLightbox, { image: imageData, mask: mask });
    if (url) {
        return React.createElement(Link, { href: url, target: (url__props === null || url__props === void 0 ? void 0 : url__props.blank) ? '_blank' : undefined, rel: (url__props === null || url__props === void 0 ? void 0 : url__props.blank) ? 'noreferrer noopener nofollow' : undefined },
            React.createElement(ImageEl, { image: imageData, mask: mask }));
    }
    return React.createElement(ImageEl, { image: imageData, mask: mask });
}
function ImageLightbox(props) {
    const { __ } = useI18n();
    const [open, setOpen] = useState(false);
    useEffect(() => {
        const onEsc = ({ key }) => {
            if (key.toUpperCase() === 'ESCAPE') {
                setOpen(false);
            }
        };
        document.addEventListener('keydown', onEsc);
        return () => {
            document.removeEventListener('keydown', onEsc);
        };
    }, []);
    return React.createElement(React.Fragment, null,
        React.createElement(ImageEl, Object.assign({}, props, { onClick: () => { setOpen(true); } })),
        React.createElement(Modal, { open: open, className: "ltg-image-lightbox" },
            React.createElement(OutsideAlerter, { className: "ltg-image-lightbox-content container", callback: () => { setOpen(false); } },
                React.createElement("button", { className: "ltg-image-lightbox-close btn btn-white btn-sm", onClick: () => { setOpen(false); } },
                    React.createElement("span", { className: "sr-only" }, __('Uždaryti', 'ltg-widgets')),
                    React.createElement("i", { className: "fas fa-times" })),
                React.createElement(ImageEl, Object.assign({}, props)))));
}
const ImageEl = ({ image, mask, onClick }) => {
    const { alt, url: url_img } = image || {};
    return React.createElement(React.Fragment, null,
        React.createElement("div", { style: onClick ? { cursor: 'pointer' } : undefined, className: `ltg-image-wrap${mask !== 'rounded' ? ` ltg-image--mask-${mask}` : ''}`, onClick: onClick },
            React.createElement(LtgImage, { className: "ltg-image", src: url_img, srcSet: image === null || image === void 0 ? void 0 : image.srcset, alt: alt })));
};
